export const attrs_btn__icon = {
    text: true,
    icon: true,
    tile: true,
    width: "43px",
    height: "48px",
};

export const attrs_input = {
    dense: true,
    outlined: true,
    hideDetails: "auto",
    persistentPlaceholder: true,
};

export const attrs_input__table = {
    flat: true,
    solo: true,
    class: "rounded-0 text-caption transparent",
    hideDetails: "auto",
    persistentPlaceholder: true,
};

export const attrs_switch = {
    inset: true,
    hideDetails: "auto",
    class: "d-inline-block pa-0 ma-0 ml-1 mr-n4",
};
